"use client"
import React from 'react'
import { motion, } from "framer-motion";
import PinCard from './PinCard';
import Image from 'next/image';
const backgroundImage = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1730458139/JDRUUJ_gtjuef.jpg'
import NotifierPic from '../../../public/notifier-pic.PNG'
import MMCPic from '../../../public/MMC-pic.png'
import MMCProject from '../../../public/MMC_project.jpg'
import AutomationProject from '../../../public/wa.jpeg'
import HospitraxProject from '../../../public/hospitrax-pic.PNG'
import NuintroxProject from '../../../public/nuintrox.PNG'
import SchoolProject from '../../../public/school.jpeg'
const showPortfolio = () => {
  return (
    <>
      <motion.div className=" relative bg-slate-300 h-[60vh] md:h-[70vh] w-full overflow-hidden">
        <Image
          src={backgroundImage}
          alt="Creative Portfolio Background - Showcasing Projects and Designs"
          height={800}
          width={800}
          // priority
          className="brightness-75  w-full  h-full overflow-hidden object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/40 to-transparent" />
      </motion.div>

      <h3 className='section-heading -mt-8 md:-mt-16 relative z-10 px-4'>
        Discover Our Software Solutions for Real-World Problems
      </h3>
      <motion.div
        className="grid grid-cols-1 gap-6 px-4 max-w-7xl mx-auto md:grid-cols-2 lg:grid-cols-3 w-full h-full text-center py-8"
      >
        {/* Commented out Forexter as per your array */}
        {/* <PinCard 
    title={'forexter.pk'} 
    projectName={'Forexter'} 
    url={'https://forexter.pk/'} 
    imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project1_qit63s.png'}
  /> */}

        <PinCard
          title={'cyltrax.com'}
          projectName={'Cyltrax'}
          url={'https://cyltrax.com/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project2_nyc8np.png'}
        />

        <PinCard
          title={'lineup.pk'}
          projectName={'Digital Singage'}
          url={'https://lineup.pk/'}
          imageURL={MMCPic}
        />

        <PinCard
          title={'Enterprise Resource Planning (ERP)'}
          projectName={'Enterprise Resource Planning (ERP)'}
          url={'/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731567203/erp_y033b2.png'}
        />

        <PinCard
          title={'trade-hub.com.pk'}
          projectName={'Hedge Play'}
          url={'https://trade-hub.com.pk/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project4_gaj94x.png'}
        />

        <PinCard
          title={'Hospital Management System (HMS)'}
          projectName={'Hospital Management System (HMS)'}
          url={'/'}
          imageURL={MMCProject}
        />

        <PinCard
          title={'hospitraxai.com'}
          projectName={'Hospitrax'}
          url={'https://hospitraxai.com/'}
          imageURL={HospitraxProject}
        />

        <PinCard
          title={'nf.lineup.pk'}
          projectName={'Notifier'}
          url={'https://nf.lineup.pk/'}
          imageURL={NotifierPic}
        />

        <PinCard
          title={'nuintrox.vercel.app'}
          projectName={'NuIntroX'}
          url={'https://nuintrox.vercel.app/'}
          imageURL={NuintroxProject}
        />

        <PinCard
          title={'NUREADY (POS)'}
          projectName={'NUREADY (POS)'}
          url={'/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731498163/1_glbeyc.png'}
        />

        <PinCard
          title={'nutrack.nubitsoft.com'}
          projectName={'Nutrack (HRMS)'}
          url={'https://nutrack.nubitsoft.com/'}
          imageURL={'https://res.cloudinary.com/dsvbvqa5m/image/upload/v1764935587/Screenshot_109_ajbgoe.png'}
        />

        <PinCard
          title={'School Management System'}
          projectName={'School Management System'}
          url={'/'}
          imageURL={SchoolProject}
        />

        <PinCard
          title={'Stock Equity Back Office (SEBO)'}
          projectName={'Stock Equity Back Office (SEBO)'}
          url={'/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731396765/sebo_bdb6pg.jpg'}
        />

        <PinCard
          title={'trade-hub.com.pk'}
          projectName={'Trade Hub'}
          url={'https://trade-hub.com.pk/'}
          imageURL={'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project3_ylvdqd.png'}
        />

        <PinCard
          title={'Whatsapp Automation'}
          projectName={'Whatsapp Automation'}
          url={'/'}
          imageURL={AutomationProject}
        />
      </motion.div>
    </>
  )
}

export default showPortfolio